export { default as ForbiddenIllustration } from "./ForbiddenIllustration";
export { default as PageNotFoundIllustration } from "./PageNotFoundIllustration";
export { default as SeoIllustration } from "./SeoIllustration";
export { default as SeverErrorIllustration } from "./SeverErrorIllustration";
export { default as UnauthorizedIllustration } from "./UnauthorizedIllustration";
export { default as UploadIllustration } from "./UploadIllustration";
